import React, { useEffect, useState } from 'react';
import Header from '../../includes/Header';
import Loader from '../../components/Loader/Loader';
import { Container } from 'react-bootstrap';
import { useFormik } from 'formik';
import { FaLock, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import { changResPaaSchema } from '../../schemas';
import { getProfile, postChangePassword } from '../../apiservices/ApiServices';

const initialValues = {
    oldpassword: '',
    password: '',
    confirmpassword: '',
}
const ChangePassword = () => {
    const [isLoading, setLoading] = useState(false);
    const [isViewPass, setIsViewPass] = useState(false);
    const [isNViewPass, setIsNViewPass] = useState(false);
    const [isCViewPass, setIsCViewPass] = useState(false);

    const [data, setData] = useState([]);
    const navigate = useNavigate();

    const getProfiles = async () => {
        try {
            const res = await getProfile();
            setData(res.data.data);
            localStorage.setItem('useData', JSON.stringify(res.data.data));
        } catch (error) {
            console.log(error.response.data.message);
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('useToken')) {
            navigate("/");
        }
        else {
            getProfiles();
        }
    }, [])

    const postChangePasswords = async (value, action) => {
        let postdata =
        {
            'current_password': value.oldpassword,
            'new_password': value.password,
            'confirm_password': value.confirmpassword,
        }
        try {
            const res = await postChangePassword(postdata);
            toast.success(res.data.message);
            action.resetForm();
            setLoading(false);
        } catch (error) {
            toast.error(error.response.data.message);
            console.log(error.response.data.data);
            setLoading(false);
        }
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: changResPaaSchema,
        onSubmit: (values, action) => {
            setLoading(true);
            postChangePasswords(values, action);
        }
    })

    return (
        <>
            <Header data={data} />
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            <section id='auth'>
                <div className='users-block'>
                    <Container>
                        <div className='users-box'>
                            <div className='titles-box'>
                                <h4>Change Password</h4>
                                <Link to={'/profile'} className='btn btn-orange'><FaUser /> Profile</Link>
                            </div>
                            <div className='forms changepass'>
                                <form id='changepass' onSubmit={handleSubmit} autoComplete="off">
                                    <div className='form-group io'>
                                        <div className="control has-icon">
                                            <label className="label auth-label" htmlFor="oldpassword">Old Password</label>
                                            <input
                                                type={isViewPass ? 'text' : 'password'}
                                                id="oldpassword"
                                                name="oldpassword"
                                                className="input v-input"
                                                autoComplete='off'
                                                value={values.oldpassword}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <div className='passio'>
                                                {isViewPass ?
                                                    <FaEyeSlash onClick={() => setIsViewPass(false)} /> :
                                                    <FaEye onClick={() => setIsViewPass(true)} />
                                                }
                                            </div>
                                            <label className="label form-icon" htmlFor="oldpassword">
                                                <FaLock />
                                            </label>
                                            {errors.oldpassword && touched.oldpassword ? (
                                                <p className='errormsg'>{errors.oldpassword}</p>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className='form-group io'>
                                        <div className="control has-icon">
                                            <label className="label auth-label" htmlFor="password">New Password</label>
                                            <input
                                                type={isNViewPass ? 'text' : 'password'}
                                                id="password"
                                                name="password"
                                                className="input v-input"
                                                autoComplete='off'
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <div className='passio'>
                                                {isNViewPass ?
                                                    <FaEyeSlash onClick={() => setIsNViewPass(false)} /> :
                                                    <FaEye onClick={() => setIsNViewPass(true)} />
                                                }
                                            </div>
                                            <label className="label form-icon" htmlFor="password">
                                                <FaLock />
                                            </label>
                                            {errors.password && touched.password ? (
                                                <p className='errormsg'>{errors.password}</p>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className='form-group io'>
                                        <div className="control has-icon">
                                            <label className="label auth-label" htmlFor="confirmpassword">Confirm Password</label>
                                            <input
                                                type={isCViewPass ? 'text' : 'password'}
                                                id="confirmpassword"
                                                name="confirmpassword"
                                                className="input v-input"
                                                autoComplete='off'
                                                value={values.confirmpassword}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <div className='passio'>
                                                {isCViewPass ?
                                                    <FaEyeSlash onClick={() => setIsCViewPass(false)} /> :
                                                    <FaEye onClick={() => setIsCViewPass(true)} />
                                                }
                                            </div>
                                            <label className="label form-icon" htmlFor="confirmpassword">
                                                <FaLock />
                                            </label>
                                            {errors.confirmpassword && touched.confirmpassword ? (
                                                <p className='errormsg'>{errors.confirmpassword}</p>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className='buttonbox'>
                                        <button type='submit' className='btn btn-green'>Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>
            {isLoading ? <Loader /> : null}
        </>
    )
}

export default ChangePassword;